/**
 * @desc 价格指数订单分页列表
 */
import {
  PagePriceIndexOrderDto,
  PriceIndexOrderQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPriceIndexOrderPageParameter = PriceIndexOrderQuery

const method = 'GET'
const url = '/trade/order/operation/queryPriceIndexOrderPage'

export const queryPriceIndexOrderPageApi = (
  params?: QueryPriceIndexOrderPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PagePriceIndexOrderDto>({
    method,
    url,
    params,
    ...config
  })
}

queryPriceIndexOrderPageApi.method = method
queryPriceIndexOrderPageApi.url = url
